import { BrowserRouter, Route, Routes } from "react-router-dom";

import {
  baseUrl,
  createNewPasswordUrl,
  customerInfoUrl,
  customersUrl,
  enterCodeUrl,
  resetPasswordUrl,
} from "../constants/Routes";
import { CreateNewPassword } from "../pages/create-new-password/CreateNewPassword";
import { CustomerInfo } from "../pages/customerInfo/CustomerInfo";
import { Customers } from "../pages/customers/Customers";
import { EnterCode } from "../pages/enter-code/EnterCode";
import { Login } from "../pages/login/Login";
import { ResetPassword } from "../pages/reset-password/ResetPassword";
import { ProtectedRoute } from "./ProtectedRoute";
import { UnprotectedRoute } from "./UnprotectedRoute";

export function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path={baseUrl}
          element={
            <UnprotectedRoute>
              <Login />
            </UnprotectedRoute>
          }
        />
        <Route
          path={resetPasswordUrl}
          element={
            <UnprotectedRoute>
              <ResetPassword />
            </UnprotectedRoute>
          }
        />
        <Route
          path={enterCodeUrl}
          element={
            <UnprotectedRoute>
              <EnterCode />
            </UnprotectedRoute>
          }
        />
        <Route
          path={createNewPasswordUrl}
          element={
            <UnprotectedRoute>
              <CreateNewPassword />
            </UnprotectedRoute>
          }
        />
        <Route
          path={customersUrl}
          element={
            <ProtectedRoute>
              <Customers />
            </ProtectedRoute>
          }
        />
        <Route
          path={customerInfoUrl}
          element={
            <ProtectedRoute>
              <CustomerInfo />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
